import React from "react"
import MetaTags from "react-meta-tags"
import { Container } from "reactstrap"
import AllStatsTable from "../../../components/Lead/allStatistics/index.jsx"

const AllStatsLeads = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>All Stats | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <AllStatsTable />
        </Container>
      </div>
    </React.Fragment>
  )
}
export default AllStatsLeads
